<template>
    <div>
        <i-form label-position="top">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <h2>Inutilizar Notas</h2>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" :class="errors.first('modelo')?'pb-4':''">
                    <form-item :error="errors.first('modelo')" label="Modelo da nota:">
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-for="(item, index) in modelos" :key="index">
                            <vs-radio v-model="form.modelo_nota" vs-name="modelo" :vs-value="item.value" name="modelo" v-validate="'required'" @input="onChange">{{item.label}}</vs-radio>
                        </vs-col>
                    </form-item>
                    <form-item :error="errors.first('ambiente')" label="Ambiente da nota:">
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" v-for="(item, index) in ambientes" :key="index">
                            <vs-radio v-model="form.ambiente_nota" vs-name="ambiente" :vs-value="item.value" name="ambiente" v-validate="'required'" @input="onChange">{{item.label}}</vs-radio>
                        </vs-col>
                    </form-item>
                </vs-col>
                <vs-col>
                </vs-col>
                <vs-row :class="errors.items.length>0?'pb-4':''">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                        <form-item :error="errors.first('série da nota')" label="Série da nota:">
                            <i-input clearable type="number" v-model="form.serie_nota" size="large" name="série da nota" v-validate="'required'" @input="onChange"></i-input>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                        <form-item :error="errors.first('número inicial')" label="Nº nota inicial:">
                            <Tooltip placement="top">
                                <i-input clearable type="number" v-model="form.numero_inicial_nota" size="large" name="número inicial" v-validate="'required'" @input="onChange"></i-input>
                                <div slot="content">
                                    <label>Número inicial da nota/faixa <br> a ser inutilizada.</label>
                                </div>
                            </Tooltip>
                        </form-item>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4">
                        <form-item label="Nº nota final:">
                            <Tooltip placement="top">
                                <i-input clearable type="number" v-model="form.numero_final_nota" size="large" @input="onChange"></i-input>
                                <div slot="content">
                                    <label>Número final da nota/faixa a ser <br> inutilizada. <br>
                                    <span class='text-danger'>
                                        <strong>Atenção</strong>
                                    </span>
                                    , se for apenas uma nota <br> a ser inutilizada, preencher este <br> campo com o mesmo valor do <br> campo:
                                    <span class='text-danger'>
                                    <strong>Nº nota inicial</strong>
                                    </span></label>
                                </div>
                            </Tooltip>
                        </form-item>
                    </vs-col>
                </vs-row>
<!--                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="4" :class="errors.first('data referência')?'pb-4':''">-->
<!--                    <form-item :error="errors.first('data referência')" label="Data Referência:">-->
<!--                        <DatePicker type="date" placement="bottom-end" v-model="form.data_referencia" format="dd/MM/yyyy" size="large" name="data referência" v-validate="'required'" @on-change="onChange"></DatePicker>-->
<!--                    </form-item>-->
<!--                </vs-col>-->
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" :class="errors.first('motivo inutilização')?'pb-4':''">
                    <form-item :error="errors.first('motivo inutilização')" label="Motivo inutilização:">
                        <i-input clearable type="text" v-model="form.motivo" size="large" name="motivo inutilização" v-validate="'required'" @input="onChange"></i-input>
                    </form-item>
                </vs-col>
            </vs-row>
        </i-form>
        <div class="floating-btn">
            <i-button v-show="show_save" @click="onSave" :loading="loading" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        id_empresa: Number,
        show_save:Boolean
    },
    data:()=>({
        loading: false,
        form:{
            modelo_nota: 55,
            ambiente_nota: 2,
            serie_nota:'', // serie da nota
            numero_inicial_nota:'', // numero inicial da nota
            numero_final_nota:'', // numero final da nota
            data_referencia:'', // date de referencia
            motivo:'' // motivo da inutilização
        },
        modelos:[
            {
                label:'NF-e(55)',
                value:55
            },
            {
                label:'NFc-e(65)',
                value:65
            }
        ],
        ambientes:[
            {
                label: 'Produção',
                value: 1
            },
            {
                label: 'Homologação',
                value: 2
            }
        ]
    }),
    watch:{
        loading(value) {
            if (!value) {
              this.form = {
                modelo_nota: 55,
                ambiente_nota: 2,
                serie_nota:'', // serie da nota
                numero_inicial_nota:'', // numero inicial da nota
                numero_final_nota:'', // numero final da nota
                data_referencia:'', // date de referencia
                motivo:'' // motivo da inutilização
              }
            }
        }
    },
    methods:{
        onSave(){
            this.loading = true;
            if (this.$validator.validateAll()) {
                Object.assign(this.form, {id_empresa: this.id_empresa})

                this.$axios.post('/clientes/disableNotes', this.form)
                    .then((response) => {
                        this.loading = false
                        this.$vs.notify({
                            title: "Sucesso",
                            text: response.data.xMotivo,
                            color: "success"
                        })
                    })
                    .catch((error) => {
                        this.loading = false
                        this.$vs.notify({
                            title: "Erro",
                            text: error.message,
                            color: "danger"
                        })
                    })
            }
        },
        onChange(){
            this.$emit("change")
            this.show_button = true
        }
    },
    created(){

    },
}
</script>

<style lang="scss" scoped>
    h2 {
        margin-bottom: 20px;
    }
    .ivu-form-item {
        width: 100%;
        margin: 10px;
    }
    .ivu-collapse {
        width: 100%;
    }
    .ivu-date-picker {
        width: 100%;
    }
    .ivu-tooltip {
        width: 100%;
    }
</style>
